import { render, staticRenderFns } from "./QzGuanLick.vue?vue&type=template&id=adac13c2&scoped=true"
import script from "./QzGuanLick.vue?vue&type=script&lang=js"
export * from "./QzGuanLick.vue?vue&type=script&lang=js"
import style0 from "./QzGuanLick.vue?vue&type=style&index=0&id=adac13c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adac13c2",
  null
  
)

export default component.exports